import React, { useEffect, useState } from "react";

const DTOEmpTrainingDetails = () => {
  return <></>;
};
export default DTOEmpTrainingDetails;
